module.exports = __webpack_public_path__ + "img/Dijlat-AL_Ahlam2.fa946821.jpg";